import { render, staticRenderFns } from "./SitesEditPage.vue?vue&type=template&id=2deea3d2&scoped=true"
import script from "./SitesEditPage.vue?vue&type=script&lang=js"
export * from "./SitesEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deea3d2",
  null
  
)

export default component.exports